import { useMemo } from 'react'
import { StackDirection } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import { WidgetProps } from './Widget'

export const useData = (): WidgetProps[] => {
  const {
    t,
    i18n: { language },
  } = useTranslation('handout')

  return useMemo(() => {
    // TODO: Wait for EN/JP translation
    const legalAndCompliance =
      language === 'th'
        ? [
            {
              title: t('contents.legal.title'),
              image: '/images/resources/form/content-6.svg',
              list: new Array(3)
                .fill(0)
                .map((_, index) => t(`contents.legal.contents.${index}`)),
            },
            {
              title: t('contents.compliance.title'),
              image: '/images/resources/form/content-7.svg',
              list: new Array(3)
                .fill(0)
                .map((_, index) => t(`contents.compliance.contents.${index}`)),
            },
          ]
        : []

    return [
      {
        title: t('contents.core.title'),
        image: '/images/resources/form/content-1.svg',
        list: new Array(2)
          .fill(0)
          .map((_, index) => t(`contents.core.contents.${index}`)),
      },
      {
        title: t('contents.implementation.title'),
        image: '/images/resources/form/content-2.svg',
        list: new Array(3)
          .fill(0)
          .map((_, index) => t(`contents.implementation.contents.${index}`)),
      },
      {
        title: t('contents.advisory.title'),
        image: '/images/resources/form/content-3.svg',
        list: new Array(3)
          .fill(0)
          .map((_, index) => t(`contents.advisory.contents.${index}`)),
      },
      {
        title: t('contents.training.title'),
        image: '/images/resources/form/content-4.svg',
        list: new Array(5)
          .fill(0)
          .map((_, index) => t(`contents.training.contents.${index}`)),
      },
      ...legalAndCompliance,
      {
        title: t('contents.selfChecklist.title'),
        image: '/images/resources/form/content-5.svg',
        list: new Array(2)
          .fill(0)
          .map((_, index) => t(`contents.selfChecklist.contents.${index}`)),
        sx: {
          gridColumn: {
            base: 1,
            md: '1 / 3',
          },
        },
        direction: { base: 'column', sm: 'row' } as StackDirection,
      },
    ]
  }, [language])
}
